import request from '@/utils/request'; // 导入配置好的 axios 实例
import { no } from 'element-plus/es/locales.mjs';

// 仪器管理模块的所有接口，统一导出
export default {
  // 1. 查询仪器列表（对应你代码中的 getList）
  // params：传入的参数（如 page、pageSize、keyword 等）
  getList(params) {
    // 分页搜索
    return request({
      url: '/instrument/',
      method: 'get',
      params // GET 请求参数会拼在 URL 后（如 ?page=1&pageSize=10）
    });
  },
  //新增仪器数据
  create(instrumentData) {
    return request({
      url: '/instrument/',
      method: 'post',
      data: instrumentData, // 前端表单数据（自动序列化为 JSON）
      headers: {
        'Content-Type': 'application/json' // 明确指定请求体为 JSON（axios 可省略，默认自动设置）
      }
    });
  },
  // 编辑仪器（PUT 请求，发送 JSON 数据）
  update(instrumentData) {
    return request({
      url: '/instrument/',
      method: 'put',
      data: instrumentData // 表单数据（含主键 instrumentNo）
    });
  },
  delete(instrumentNo) {
    if (!instrumentNo) {
      console.error("删除失败：仪器编号（instrumentNo）不能为空");
      return Promise.reject(new Error("仪器编号不能为空"));
    }
    return request({
      url: `/instrument/${instrumentNo}`,
      method: 'delete',

    })
  }

};